export const WRITE_DEX_SESSION_KEYS = "wdskd";
export const IMPORTED_SESSION_KEYS = "isks";
export const IMPORTED_SESSION_KEYS_CLEARED = "iskc";
export const DEPOSIT_INDICATOR_LS_KEY = "dik";
export const SUBACCOUNT_ADDRESS_KEY_PREFIX = "sakd:";
export const SUBACCOUNT_ADDRESS_LEGACY_KEY = "sakd";
export const SELECTED_ACCOUNTS_TAB_KEY = "satk";
export const PNL_DISPLAY_KEY = "pdk";
export const SHARE_IDEA_CARD_KEY = "sicck";
export const FOLLOW_X_MODAL_SKIPPED_KEY = "fxmosk";
export const USER_SELECTED_CURRENCY_KEY = "usckd";
export const OPENED_WINNERS_FORM_KEY = "owfk";
export const SELECTED_SUBACCOUNT_ITEM_KEY = "ssiak";
export const LATEST_SEEN_ANNOUNCEMENT_TIMESTAMP_KEY = "lsatk";
export const PREDEPOSIT_USDC_REWARDS_SEEN_KEY = "pdursk";
export const REWARDS_CLAIM_TOAST_SEEN_KEY = "rctsk";
export const TARGETED_ANNOUNCEMENT_SEEN_KEY = "tank";

// Asset Details Table Keys
export const POSITIONS_SORT_KEY = "pts";
export const POSITIONS_COLUMN_LAYOUT_KEY = "pclk";
export const OPEN_ORDERS_COLUMN_LAYOUT_KEY = "ooclk";
export const TWAPS_COLUMN_LAYOUT_KEY = "twclk";
export const TWAP_HISTORY_COLUMN_LAYOUT_KEY = "thclk";
export const TRADE_HISTORY_COLUMN_LAYOUT_KEY = "trhclk";
export const FUNDING_HISTORY_COLUMN_LAYOUT_KEY = "fhclk";
export const ORDER_HISTORY_COLUMN_LAYOUT_KEY = "ohclk";

// KEYLESS KEYS
export const KEYLESS_ACCOUNTS_KEY = "kak";

// Mesh Access Tokens
export const MESH_ACCESS_TOKENS = "mac";

// Cross-chain (NEAR Intents) deposits already turned into a progress card. The server keeps
// reporting a settled delivery forever, so without this the card would reappear every poll after
// the user dismissed it.
//
// "xidk2": the entries used to be keyed on the deposit address, which now identifies a long-lived
// Intents account rather than one send. A stale ledger would suppress every real card for an
// address the user had already dealt with once.
export const XCHAIN_IMPORTED_DEPOSITS_KEY = "xidk2";

// The same, for cross-chain withdrawals. A separate ledger rather than a shared one: the two are
// keyed on 1Click deposit addresses from opposite directions, and a collision would silently
// suppress a card rather than fail.
export const XCHAIN_IMPORTED_WITHDRAWALS_KEY = "xiwk";

// Fun deposit items already turned into a progress card, keyed `<id>:p|e` so a dismissed
// placeholder still comes back once evidence backs it.
export const FUN_IMPORTED_PAYMENTS_KEY = "fipk";

// Sui owner-address storage re-key migration sentinel (see use-sui-owner-storage-migration.ts).
// Holds the Sui addresses already migrated, so a user with several Sui accounts gets each one
// migrated exactly once.
export const SUI_OWNER_KEY_MIGRATED_KEY = "sokm";

// SessionKeys Cache
export const CACHE_SESSION_KEYS_KEY = "cskkd";

// local ephemeral key pair
export const LOCAL_EPHEMERAL_KEY_PAIR_KEY = "lekpk";

// PREDEPOSIT KEYS (kept for points page)
export const PREDEPOSIT_CLOSED_TRANSITIONED_CACHE_KEY = "pdctrk";
export const PREDEPOSIT_USDC_REWARDS_CACHE_KEY = "pdurck";
export const TRADE_MAINNET_WARNING_ACK_KEY = "tgmwak";

// Pending referral code stored after /r/<code> link visit or in the wallet-connect
// modal, to be redeemed once a wallet connects. Storage value left as the original
// "mtrrc" so existing pending codes in users' browsers continue to redeem.
export const PENDING_REFERRAL_CODE_KEY = "mtrrc";

// Private names an affiliate gives the addresses in their downline. Suffixed per
// affiliate account so a shared browser never shows one affiliate another's notes.
export const AFFILIATE_CLIENT_NAMES_KEY = "acnk";

// Trading Sounds
export const MUTE_TRADING_SOUNDS_KEY = "mtsk";

// Global Announcement Banner
export const GLOBAL_ANNOUNCEMENT_BANNER_DISMISSED_KEY = "gabdk";

// Wallet selector last-used preferences
export const LAST_WALLET_TAB_KEY = "lwtk";
export const LAST_EVM_CHAIN_KEY = "leck";

// TP/SL Preferences (cookies)
export const TP_VALUE_TYPE_COOKIE = "tp-vt";
export const SL_VALUE_TYPE_COOKIE = "sl-vt";
export const SHOW_TPSL_COOKIE = "show-tpsl";

// SETTINGS KEYS
export const UserPreferenceKeys = {
  LAST_LOCAL_UPDATE: "lud",
  MAX_SLIPPAGE: "msk",
  MARKET_CLOSE_CONFIRMATION: "pcck",
  PLACE_ORDER_CONFIRMATION: "pock",
  CUSTOM_SUBACCOUNT_NAMES: "csk",
  CUSTOM_DELEGATIONS_METADATA: "cdmk",
  TRADING_MODE: "tmk",
  WATCHED_MARKETS: "wmk",
  CACHE_SESSION_KEYS: "csk",
};

// TradingView Chart State
export const CHART_STATE_KEY = "dcbl-chart-state-v1";
export const CHART_STUDY_KEY = "dcbl-chart-study-v1";

// Last settled trial_id this browser reported — cross-tab dedupe for fft_settle_observed.
export const FFT_SETTLE_OBSERVED_KEY = "fsok";

// PWA Install Banner
// Combined snooze state ({ count, until }) — written atomically via a single
// useLocalStorage setter to avoid count/until drift on rapid dismisses.
export const PWA_INSTALL_SNOOZE_KEY = "pisk";
export const PWA_INSTALLED_KEY = "pik";
// One-shot sentinel: has `analytics.pwa.installed` been fired for this device
// yet? Lets us measure iOS conversions (where the `appinstalled` event never
// fires) by treating the first standalone-mode launch as the install event.
export const PWA_INSTALLED_REPORTED_KEY = "pirk";

// Survives the reload the transcript-scroll bug needs, so arming it once is enough.
export const AGENT_SCROLL_PROBE_KEY = "aspk";

export const AGENT_RAIL_PANEL_ORDER_KEY = "arpok";
export const AGENT_RAIL_PANEL_STATE_KEY = "arpsk";
export const AGENT_RAIL_PINNED_MARKETS_KEY = "arpmk";

// Encryption rollout
// Stable per-device id used to bucket the encryption rollout percentage when
// RudderStack's anonymous id isn't available. Generated once, then reused.
export const ENCRYPTION_DEVICE_ID_KEY = "encdid";

// Sentry's `user.id` for logged-out traffic. Deliberately separate from
// ENCRYPTION_DEVICE_ID_KEY: repointing that key reshuffles every device's
// encryption bucket, and the two have opposite availability contracts.
export const ANONYMOUS_ID_KEY = "said";

export const AGENT_ORDER_ATTEMPT_KEY = "aoak";

// First/last marketing touch ({ first_touch, last_touch }), sent as identify traits.
export const ATTRIBUTION_KEY = "attk";
// sessionStorage: dev-only override_wallet key, captured before the URL is sanitized.
export const OVERRIDE_WALLET_SESSION_KEY = "owsk";
